import type { AreaRoute } from "./areaRoute";
import { lazyPage } from "../../lib/lazyPage";
const WeeklyReportPage = lazyPage(() => import("../hubs/OperationsPages"), "WeeklyReportPage");
const AlertsPage = lazyPage(() => import("../operations/screens/AlertsScreen"), "AlertsPage");
const AssemblyTreesPage = lazyPage(() => import("../operations/screens/AssemblyTreesScreen"), "AssemblyTreesPage");
const LineOfBalancePage = lazyPage(() => import("../operations/screens/LineOfBalanceScreen"), "LineOfBalancePage");
const OutOfSequenceBuyOffPage = lazyPage(() => import("../operations/screens/OutOfSequenceScreen"), "OutOfSequenceBuyOffPage");
const MasterSchedulePage = lazyPage(() => import("../operations/screens/MasterScheduleScreen"), "MasterSchedulePage");
const WipPage = lazyPage(() => import("../operations/screens/WipScreen"), "WipPage");
const WorkOrderDetailPage = lazyPage(() => import("../operations/screens/WorkOrderDetailScreen"), "WorkOrderDetailPage");
const WorkOrdersPage = lazyPage(() => import("../operations/screens/WorkOrdersScreen"), "WorkOrdersPage");
const ReadyForOperationsPage = lazyPage(() => import("../operations/screens/ReadyForOperationsScreen"), "ReadyForOperationsPage");

export {
  AlertsPage,
  AssemblyTreesPage,
  LineOfBalancePage,
  MasterSchedulePage,
  OutOfSequenceBuyOffPage,
  WeeklyReportPage,
  WipPage,
  WorkOrderDetailPage,
  WorkOrdersPage,
  ReadyForOperationsPage
};

export const operationsRoutes: AreaRoute[] = [];
